export default {
  pl: {
    // Globals
    allFlats: 'Liczba mieszkań',
    available: 'Dostępne',
    loading: 'Ładowanie',
    loading_building: 'Ładowanie modułu 3D',
    loading_tour: 'Ładowanie wirtualnego spaceru',
    back: 'Powrót',
    back2: 'Wstecz',

    // Topbar
    choose_city: 'Wybierz miasto',
    choose_investment: 'Wybierz inwestycje',
    choose_building: 'Wybierz budynek',
    choose_floor: 'Wybierz piętro',
    choose_flat: 'Wybierz mieszkanie',
    wishlist: 'Schowek',

    // Breadcrumbs
    building: 'Budynek',
    stage: 'Etap',
    floor: 'Piętro',
    groundFloorShort: 'P',

    // Legend
    room1: '1-pokojowe',
    room2: '2-pokojowe',
    room3: '3-pokojowe',
    room4: '4-pokojowe',
    room5: '5-pokojowe',

    // Flat
    from: 'od',
    to: 'do',
    apartment: 'Lokal',
    flat: 'Mieszkanie',
    local: 'Lokal usługowy',
    investment: 'Inwestycja',
    number: 'Numer',
    area: 'Powierzchnia',
    rooms: 'Pokoje',
    balcony: 'Balkon',
    status: 'Status',
    sale: 'Promocja',
    status_available: 'Dostępne',
    status_reserved: 'Zarezerwowane',
    status_sold: 'Sprzedane',
    status_planned: 'Planowany',
    hideFilters: 'Zwiń filtry',
    see: 'Zobacz',

    findApartment: 'Znajdź mieszkanie',
    surface: 'Metraż',
    numberOfRooms: 'Liczba pokoi',
    price: 'Cena',
    chooseFromList: 'Wybierz z listy...',
    availableFlats: 'Dostępne mieszkania',
    filterFlats: 'Filtruj mieszkania',
    removeFilters: 'Usuń filtry',
    removeAll: 'Usuń wszystkie',
    flatsInWishlist: 'Mieszkań w schowku',
    noWishlistFlats: 'Brak mieszkań w schowku',
    downloadPDF: 'Pobierz kartę',
    addToWishlist: 'Dodaj do schowka',
    removeFromWishlist: 'Usuń ze schowka',

    // Form
    ask: 'Zapytaj',
    acceptAll: 'Zaznacz wszystkie zgody',
    name: 'Imię i nazwisko',
    surname: 'Nazwisko',
    email: 'Adres e-mail',
    phone: 'Numer telefonu',
    message: 'Wiadomość',
    nameErrorReq: 'Proszę o podanie imienia i nazwiska',
    surnameErrorReq: 'Proszę o podanie nazwiska',
    emailErrorReq: 'Proszę podać adres e-mail',
    emailErrorInvalid: 'Adres email jest nieprawidłowy',
    phoneErrorReq: 'Proszę podać numer telefonu',
    phoneErrorInvalid: 'Numer telefonu jest nieprawidłowy',
    termsErrorReq: 'Proszę o zaznaczenie zgód',
    messageErrorReq: 'Proszę podać treść wiadomości',
    sendMessage: 'Wyślij wiadomość',
    errorMessage: 'Coś poszło nie tak',
    successMessage: 'Wiadomość została wysłana!',
    checkOut: 'Sprawdź',
    goBackToFlat: 'Wróć do karty mieszkania',
    noPreview: 'Brak podglądu',
    nr: 'Nr',
    pool: 'Basen',
    lobby: 'Lobby',

    cardView: 'Widok kart',
    listView: 'Widok listy',
    noMatchingFlats: 'Żadne mieszkanie nie spełnia kryteriów wyszukiwania',
    askAboutFlats: 'Zapytaj o mieszkania',
    askAboutFlat: 'Zapytaj o mieszkanie',
  },
};
